import { createContext, useContext, useState, useEffect, PropsWithChildren } from "react";
import { useRestClientContext } from "./RestClientContext";

import Preloader from "../components/UI/Preloader/Preloader";

export interface EditableFieldValue {
	value: string;
	friendly: string;
}

export type EditableFieldValueCollection = Record<string, EditableFieldValue[]>;

const PropertyEditContext = createContext<EditableFieldValueCollection>({});

const PropertyEditContextProvider = ({ children }: PropsWithChildren) => {
	const client = useRestClientContext();
	const [editableFieldValues, setEditableFieldValues] = useState<EditableFieldValueCollection>({});

	useEffect(() => {
		client.v3.getEditableFieldValues().then((editableFieldValues: EditableFieldValueCollection) => {
			setEditableFieldValues(editableFieldValues);
		});
	}, [client]);

	const { Provider } = PropertyEditContext;

	return (
		<Provider value={editableFieldValues}>
			{editableFieldValues ? children : <Preloader status="Loading editable fields..." />}
		</Provider>
	);
};

export { PropertyEditContextProvider };

export function usePropertyEditContext() {
	return useContext(PropertyEditContext);
}
